import React, { useState } from "react";

export function PasswordField({ id, label, value, onChange, testId, autoComplete = "current-password", showLabel = "👁", hideLabel = "🙈" }) {
  const [show, setShow] = useState(false);
  const [caps, setCaps] = useState(false);
  return (
    <label className="og-password">
      {label}
      <input
        id={id}
        className="og-input"
        type={show ? "text" : "password"}
        value={value}
        autoComplete={autoComplete}
        onChange={(e) => onChange(e.target.value)}
        onKeyUp={(e) => setCaps(Boolean(e.getModifierState && e.getModifierState("CapsLock")))}
        data-testid={testId}
      />
      <button
        type="button"
        className="og-password__eye"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? hideLabel : showLabel}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {show ? "🙈" : "👁"}
      </button>
      {caps ? <small className="og-hint">Caps Lock</small> : null}
    </label>
  );
}
